module.exports = __webpack_public_path__ + "img/download-3-panel-2.4f07d880.png";